import { Component } from '@angular/core';

@Component({
  selector: '[app-view]',
  styles: [
    `
      :host {
        height: 100%;
      }
    `,
  ],
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {}

console.log('app.component.ts');
